import { jsx, jsxs } from "react/jsx-runtime";
import { Dropdown } from "../Dropdown/Dropdown.js";
import { Link } from "../Link/Link.js";
import { LocaleSelector } from "../LocaleSelector/LocaleSelector.js";
import styles from "./Nav.module.scss.js";
function Nav(props) {
  return /* @__PURE__ */ jsx("nav", { "aria-label": props.label, children: /* @__PURE__ */ jsxs("ul", { className: styles.list, children: [
    props.localeSelector && /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
      LocaleSelector,
      {
        locales: props.localeSelector.locales,
        baseURL: props.baseURL,
        staging: props.staging
      }
    ) }),
    props.navItems.map((item) => /* @__PURE__ */ jsx("li", { children: item.type === "NavDropdown" ? /* @__PURE__ */ jsx(Dropdown, { ...item }) : /* @__PURE__ */ jsx(Link, { ...item }) }, item.label))
  ] }) });
}
export {
  Nav
};
